import XmarkCircleFill from './XmarkCircleFill';

export default XmarkCircleFill;
